<div class="documents-viewer">
  <div class="documents-viewer-header-action">
    <div class="announcement-details">
      <div class="announcement-type display-flex">
        <div class="announcement-detail-title">Document Type:&nbsp;</div>
        <div class="detail-value">{{ documentType || "-" }}</div>
      </div>
      <div class="date-published-text display-flex">
        <div class="announcement-detail-title">Date Published:&nbsp;</div>
        <div class="detail-value">{{ datePublish || "-" }}</div>
        <div *ngIf="period" class="display-flex">
          <div class="announcement-detail-title">&nbsp;| Period:&nbsp;</div>
          <div class="detail-value">{{ period || "-" }}</div>
        </div>
      </div>
    </div>
    <div class="guidance-navigation" *ngIf="hasGuidance">
      <div class="guidance-title">
        <va-icon
          [name]="'guidance'"
          size="medium"
          class="data-setting-icon guidance-icon"
        ></va-icon>
        Guidance
      </div>
      <div class="guidance-navigator">
        <va-icon
          [name]="'chevron-left'"
          class="data-setting-icon navigator-element"
          size="small"
          (click)="onPrevGuidance()"
        ></va-icon>
        <div class="guidance-index">
          {{ currentGuidance }}
        </div>
        <div class="navigator-element">/</div>
        <div class="guidance-count navigator-element">
          {{ guidanceCount }}
        </div>
        <va-icon
          [name]="'chevron-right'"
          class="data-setting-icon navigator-element"
          size="small"
          (click)="onNextGuidance()"
        ></va-icon>
      </div>
    </div>
  </div>
  <div class="document-viewer-content">
    <!-- <div
      class="documents-viewer-sidebar"
      [ngClass]="{
        'documents-viewer-sidebar--collapsed': !isLeftSidebarActive
      }"
    >
      <div
        class="documents-viewer-sidebar-handle documents-viewer-sidebar-handle-left"
        (click)="handleleftsidebarClick()"
      >
        <va-icon
          *ngIf="!isLeftSidebarActive"
          size="small"
          name="arrow-circle-right"
          class="sider-icon"
        ></va-icon>
        <va-icon
          *ngIf="isLeftSidebarActive"
          size="small"
          name="arrow-circle-left"
          class="sider-icon"
        ></va-icon>
      </div>
      <div class="sidebar-content">left sidebar</div>
    </div> -->
    <div class="document-viewer-section">
      <div style="height: 400px" *ngIf="gettingPDFURL && !filingsError"></div>
      <div class="iframe-container" *ngIf="!filingsError">
        <iframe
          [src]="viewModalSrc"
          id="filingsFrame"
          frameborder="0"
          allowfullscreen
          *ngIf="filingFileType === 'pdf' && !filingsError && !gettingPDFURL"
        ></iframe>
        <iframe
          id="filingsFrame"
          frameborder="0"
          allowfullscreen
          *ngIf="
            (filingFileType === 'htm' || filingFileType === 'html') &&
            !filingsError
          "
        ></iframe>
      </div>
      <div id="filings-error" class="error-container" *ngIf="filingsError">
        <div class="error-msg">
          <va-icon name="info-circle" class="info-icon"></va-icon>
          <span class="error-text">Filings not found</span>
        </div>
      </div>
    </div>

    <!-- <div
      class="documents-viewer-sidebar"
      [ngClass]="{
        'documents-viewer-sidebar--collapsed': !isRightSidebarActive
      }"
    >
      <div
        class="documents-viewer-sidebar-handle documents-viewer-sidebar-handle-right"
        (click)="handleRightSidebarClick()"
      >
        <va-icon
          *ngIf="!isRightSidebarActive"
          size="small"
          name="arrow-circle-left"
          class="sider-icon"
        ></va-icon>
        <va-icon
          *ngIf="isRightSidebarActive"
          size="small"
          name="arrow-circle-right"
          class="sider-icon"
        ></va-icon>
      </div>
      <div class="sidebar-content">Right sidebar</div>
    </div> -->
  </div>
</div>
